import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private static readonly DEFAULT_THEME = 'arya-green';
  private static readonly DARK_THEMES = ['arya-green'];

  private themeSubject = new BehaviorSubject<string>(
    localStorage.getItem('cmsTheme') ?? ThemeService.DEFAULT_THEME
  );
  public theme$ = this.themeSubject.asObservable();
  public isDark$ = this.theme$.pipe(map(t => ThemeService.DARK_THEMES.includes(t)));

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.setTheme(this.themeSubject.getValue());
  }

  setTheme(theme: any) {
    let themeLink = this.document.getElementById(
      'app-theme'
    ) as HTMLLinkElement;

    if (themeLink) {
      themeLink.href = theme + '.css';
    }

    const isDark = ThemeService.DARK_THEMES.includes(theme);
    this.document.body.classList.toggle('dark-mode', isDark);
    this.document.body.classList.toggle('light-mode', !isDark);

    localStorage.setItem('cmsTheme', theme);
    this.themeSubject.next(theme);
  }

  toggle() {
    const current = this.themeSubject.getValue();
    const next = current === 'arya-green' ? 'new-green' : 'arya-green';
    this.setTheme(next);
  }
}
